<template>
  <div class="chart-box">
    <div
      class="title"
      v-if="config.title && config.title.visible"
    >
      {{ config.title.text }}
      <el-tooltip
        class="item"
        effect="dark"
        :content="config.title.titleContentInfo"
        placement="top-start"
        v-if="config.title.titleContentInfo&&config.title.titleContentInfo!==''"
      >
        <i class="el-icon-info"></i>
      </el-tooltip>
    </div>
    <div
      :id="id"
      :style="{
        height: config.title && config.title.visible ? `calc(100% - 20px)` : '100%'
      }"
      ref="chart-container"
      class="line-wrap xxxxxxxxxx"
      v-if="showType === 'chart'"
    ></div>
    <card v-if="showType === 'card'" :config="config" :chart-data="copyData"></card>
    <text-c v-if="showType === 'cardText'" :config="config" :chart-data="copyData"></text-c>
    <text-c-v1 v-if="showType === 'cardText' && version === 'v1'" :config="config" :chart-data="copyData"></text-c-v1>
    <pure-text v-if="showType === 'pureText'" :config="config"></pure-text>
    <card-mul v-if="showType === 'cardMul'" :config="config" :chart-data="copyData"></card-mul>
    <define-table v-if="showType === 'table' && version === 'v3'" :config="config" :chart-data="copyData"></define-table>
    <define-table-v1 v-if="showType === 'table' && version === 'v1'" :config="config" :chart-data="copyData"></define-table-v1>
    <custom-funnel v-if="showType === 'customFunnel'" :config="config" :chart-data="copyData"></custom-funnel>
    <custom-funnel-v1 v-if="showType === 'customFunnel' && version === 'v1'" :config="config" :chart-data="copyData"></custom-funnel-v1>
    <card-Three v-if="showType === 'cardThree'" :config="config" :chart-data="copyData"></card-Three>
    <frame v-if="showType === 'frame'" :config="config"></frame>
    <abbreviation
      v-if="showType === 'abbreviation'"
      :id="id"
      :config="config"
      :chart-data="copyData"
    ></abbreviation>
    <select-c
      v-if="showType === 'select'"
      :config="config"
      :chart-data="copyData"
      :id="id"
      @openSelectPage="openSelectPage"
    ></select-c>
    <chinaMap
      v-if="showType === 'chinaMap'"
      :config="config"
      :chart-data="copyData"
      :id="id"
    ></chinaMap>
    <legendTag1
      v-if="showType === 'legendTag'"
      :config="config"
      :chart-data="copyData"
    ></legendTag1>
    <worldMap
      v-if="showType === 'world'"
      :id="id"
      :config="config"
      :chart-data="copyData"
    ></worldMap>
    <treeTable
      v-if="showType === 'treeTable'"
      :id="id"
      :config="config"
      :chart-data="copyData"
    ></treeTable>
    <targetColumn
      v-if="showType === 'targetColumn'"
      :id="id"
      :config="config"
      :chart-data="copyData"
    ></targetColumn>
  </div>
</template>

<script>
import { WordCloud, Treemap, Gauge, Liquid, Chord, RadialBar, Scatter, Line, Column, Pie, Area, Funnel, Bar, Radar, DualAxes, Rose, Sankey } from '@antv/g2plot'
import card from './card'
import cardMul from './card2'
import text from './text'
import textV1 from './textV1'
import defineTable from './table'
import defineTableV1 from './table-v1'
import customFunnel from './customFunnel'
import customFunnelV1 from './customFunnelV1'
import frame from './frame'
import selectC from './SelectC'
import pureText from './pureText'
import cardThree from './card3'
import chinaMap from './chinaMap.vue'
import legendTag1 from './legendTag-1.vue'
// import selectChart from './SelectChart'
import { getChartAttr } from '../common'
import abbreviation from './abbreviation.vue'
import worldMap from './worldMap.vue'
import treeTable from './treeTable.vue'
import targetColumn from './targetColumn.vue'

export default {
  props: {
    version: {
      type: [String],
      default: 'v3'
    },
    id: {
      type: [Number, String],
      default: ''
    },
    config: {
      type: Object,
      default () {
        return {}
      }
    },
    chartData: {
      type: [Array, Object],
      default () {
        return []
      }
    },
    spareData: {
      type: [Array, Object],
      default () {
        return []
      }
    }
  },
  components: {
    worldMap,
    card,
    'text-c': text,
    'text-c-v1': textV1,
    cardMul,
    defineTable,
    customFunnel,
    customFunnelV1,
    frame,
    selectC,
    pureText,
    defineTableV1,
    cardThree,
    chinaMap,
    legendTag1,
    abbreviation,
    treeTable,
    targetColumn
    // selectChart
  },
  data () {
    return {
      graph: null,
      showType: 'chart',
      showSelect: {
        is: false,
        data: {}
      }
    }
  },
  computed: {
    copyData () {
      let cloneData = this.$lodash.cloneDeep(this.chartData)
      return this?.chartData?.['tBody'] ? this.chartData['tBody'] : this.setNumberData(cloneData, this.config)
    }
  },
  methods: {
    showChart () {
      const data = this.copyData
      this.$set(this.config, 'supportCSSTransform', true)
      this.$set(this.config, 'animation', false)
      const config = this.config
      let type = this.config.chartType
      switch (type) {
        case 'world':
          this.showType = 'world'
          break
        case 'singleLine':
          this.graph = new Line(this.id, {
            data,
            ...config
            // renderer: 'svg'
          })
          this.graph.render()
          break
        case 'line':
          this.setChartAttr(config, type)
          this.graph = new Line(this.id, {
            data,
            ...config
            // renderer: 'svg'
          })
          this.graph.render()
          break
        case 'singleColumn':
          this.graph = new Column(this.id, {
            data,
            ...config
            // renderer: 'svg'
          })
          this.graph.render()
          break
        case 'abbreviation':
          this.showType = 'abbreviation'
          break
        case 'column':
          this.setChartAttr(config, type)
          this.graph = new Column(this.id, {
            data,
            ...config
            // renderer: 'svg'
          })
          this.graph.render()
          break
        case 'pie':
          this.graph = new Pie(this.id, {
            data,
            ...config
            // renderer: 'svg'
          })
          this.graph.render()
          break
        case 'singleArea':
          this.graph = new Area(this.id, {
            data,
            ...config
            // renderer: 'svg'
          })
          this.graph.render()
          break
        case 'area':
          this.setChartAttr(config, type)
          this.graph = new Area(this.id, {
            data,
            ...config
            // renderer: 'svg'
          })
          this.graph.render()
          break
        case 'funnel':
          this.graph = new Funnel(this.id, {
            data,
            ...config
            // renderer: 'svg'
          })
          this.graph.render()
          break
        case 'bar':
        case 'stackGroupBar':
          this.graph = new Bar(this.id, {
            data,
            ...config
            // renderer: 'svg'
          })
          this.graph.render()
          break
        case 'radar':
          this.setChartAttr(config, type)
          this.graph = new Radar(this.id, {
            data,
            ...config
            // renderer: 'svg'
          })
          this.graph.render()
          break
        case 'areaDpolyLine':
        case 'singleLineDual':
          this.graph = new DualAxes(this.id, {
            data: [this.spareData, this.spareData],
            ...config
            // renderer: 'svg'
          })
          this.graph.render()
          break
        case 'stackeDpolyLine':
          this.graph = new DualAxes(this.id, {
            data: this.spareData,
            ...config
            // renderer: 'svg'
          })
          this.graph.render()
          break
        case 'singleRose':
          this.graph = new Rose(this.id, {
            data,
            ...config
            // renderer: 'svg'
          })
          this.graph.render()
          break
        case 'singleGauge':
          this.graph = new Gauge(this.id, {
            data,
            ...config
            // renderer: 'svg'
          })
          this.graph.render()
          break
        case 'chinaMap':
          this.showType = 'chinaMap'
          break
        case 'sanKey':
          this.graph = new Sankey(this.id, {
            data,
            ...config
            // renderer: 'svg'
          })
          this.graph.render()
          break
        case 'rangk':
          this.showType = 'card'
          break
        case 'singleLegend':
          this.showType = 'legendTag'
          break
        case 'singleScatter':
          this.graph = new Scatter(this.id, {
            data,
            ...config
            // renderer: 'svg'
          })
          this.graph.render()
          break
        case 'stackRadialBar':
        case 'singleRadialBar':
          this.graph = new RadialBar(this.id, {
            data,
            ...config
            // renderer: 'svg'
          })
          this.graph.render()
          break
        case 'singleChord':
          this.graph = new Chord(this.id, {
            data,
            ...config
            // renderer: 'svg'
          })
          this.graph.render()
          break
        case 'singleLiquid':
          let o = Object.assign(config, { animation: true })
          this.graph = new Liquid(this.id, {
            data,
            ...o
          })
          console.log(config)
          this.graph.render()
          break
        case 'complexRectangularTree':
          this.graph = new Treemap(this.id, {
            data: data[0],
            ...config
            // renderer: 'svg'
          })
          this.graph.render()
          break
        case 'singleWorldCloud':
          this.graph = new WordCloud(this.id, {
            data,
            ...config
            // renderer: 'svg'
          })
          this.graph.render()
          break
        default:
          this.showType = type
          break
      }
    },
    setNumberData (data = [], config) {
      if (config.isDual || config.chartType === 'abbreviation') {
        return data
      }
      return (data ?? []).map(item => {
        for (let prop in item) {
          // 针对条形图
          if (!isNaN(parseFloat(config['yField']))) {
            if (prop === config['angleField'] || prop === config['yField']) {
              let temp = parseFloat(item[prop])
              if (!isNaN(temp)) {
                item[prop] = temp
              }
            }
          }
        }
        return item
      })
    },
    setChartAttr (config) {
      let { seriesField, tField, chartType } = config
      let { label, val } = getChartAttr(chartType, config)
      config[label] = (args) => {
        if (args) {
          if (args[seriesField] === tField) {
            return val
          }
        }
      }
      config[label]()
    },
    openSelectPage () {
      const config = this.config
      this.$emit('openSelect', {
        config: config,
        data: this.chartData
      })
      // this.showSelect.is = true
    },
    closeSelect (flag) {
      this.showSelect.is = false
      // 删除dialog节点
      const app = document.getElementById('app')
      const selectChart = document.getElementsByClassName('select-chart-c')[0]
      app.removeChild(selectChart)
      if (flag) {
        this.$bus.$emit('searchSelect')
      }
    },
    getTitleConfig () {
      let fontSize = this.config.title?.style?.fontSize
      fontSize = fontSize ? fontSize + 'px' : 'initial'
      return {
        height: fontSize,
        fontSize: fontSize,
        fontWeight: this.config.title?.style?.fontWeight,
        fontFamily: this.config.title?.style?.fontFamily ?? 'auto'
      }
    }
  },
  mounted () {
    setTimeout(() => {
      this.showChart()
    }, 10)
  }
}
</script>

<style lang="stylus" scoped>
.line-wrap
  box-sizing border-box
  height 100%
.chart-box
  box-sizing border-box
  height 100%
  .title
    font-size 14px
    font-weight bold
    color #FFFFFF
    line-height 22px
    height 20px
</style>
